import * as React from "react";
import { IconButton, useDisclosure } from "@chakra-ui/react";
import { BiEditAlt } from "react-icons/bi";
import { Modal } from "components";
import { Fragments } from "requests";
import Form from "../../../form";
import { useUpdateMedication } from "./duck";

interface EditProps {
  record: Fragments.StoredCurrentMedications[number];
}

const Edit: React.FC<EditProps> = ({
  record: { _id, fakeId, dose, frequency, lastGivenAt, medication }
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const onSubmit = useUpdateMedication(_id || null, fakeId || null, onClose);

  return (
    <>
      <IconButton
        onClick={onOpen}
        size="2xs"
        variant="ghost"
        colorScheme="gray"
        aria-label="Edit"
        icon={<BiEditAlt />}
      />
      {isOpen && (
        <Modal isOpen onClose={onClose} title="Edit Medication" size="lg">
          <Form
            defaultValues={{
              dose,
              frequency,
              lastGivenAt: new Date(lastGivenAt),
              medication: medication || ""
            }}
            onSubmit={onSubmit}
            onCancel={onClose}
            submitText="Update Medication"
          />
        </Modal>
      )}
    </>
  );
};

export default Edit;
